import { pluralize } from '#shared/lib/string';

const MAX_BADGES_COUNT = 2;

export const BADGE_INFO_BLOCK_TITLE = pluralize(
    MAX_BADGES_COUNT,
    'На товаре могут отображаться до %d бейджа',
    'На товаре могут отображаться до %d-х  бейджей одновременно',
    'На товаре могут отображаться до %d-и бейджей одновременно'
);

const COLORS = {
    BLACK: '#1A1919FF',
    GRAY: '#B6BCC8FF',
    BLUE: '#366EFFFF',
    PURPLE: '#730CC5FF',
    GREEN: '#2F9E42FF',
    RED: '#FF1654FF',
    ORANGE: '#F8604AFF',
    YELLOW: '#F2BE00FF',
    PINK: '#FF3399FF',
};

export const BADGE_COLOR_ITEMS = [
    {
        value: COLORS.BLACK,
        content: 'Чёрный',
    },
    {
        value: COLORS.GRAY,
        content: 'Серый',
    },
    {
        value: COLORS.BLUE,
        content: 'Синий',
    },
    {
        value: COLORS.PURPLE,
        content: 'Фиолетовый',
    },
    {
        value: COLORS.GREEN,
        content: 'Зелёный',
    },
    {
        value: COLORS.RED,
        content: 'Красный',
    },
    {
        value: COLORS.ORANGE,
        content: 'Оранжевый',
    },
    {
        value: COLORS.YELLOW,
        content: 'Жёлтый',
    },
    {
        value: COLORS.PINK,
        content: 'Розовый',
    },
];

export const BADGE_LABEL_MIN_LENGTH = 1;
export const BADGE_LABEL_MAX_LENGTH = 16;
export const BADGE_TOOLTIP_MAX_LENGTH = 140;
